import { IEvent } from "../../../models/Event"

export const DetailsMainHeader: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <div className="main-details-container">
            <img src={event.detailsImage} alt="" />
        </div>

    )
}
